export default class StrokeMap<T> {
    public fly: T;
    public back: T;
    public breast: T;
    public free: T;
}